import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import { UpdateExternalTestLabTestResultRequest } from '../../../../../../../../core/projects.actions';
import { takeUntil } from 'rxjs/operators';
import { ProjectsService } from '../../../../../../../../core/projects.service';

@Component({
    selector: 'app-external-test-result-details',
    templateUrl: './external-test-result-details.component.html',
    styleUrls: ['./external-test-result-details.component.scss'],
    standalone: false
})
export class ExternalTestResultDetailsComponent implements OnInit, OnDestroy {
  @Input() data: any;
  mediaFiles = [];
  failIsSelected = false;
  passIsSelected = false;
  errorMessages: any = {};
  errorMessageMap = {
    comment: { required: 'This field is required.' },
  };
  private resultMap = { 'Passed': 'passed', 'Failed': 'failed' };
  form: FormGroup = new FormGroup({
    result: new FormControl({ value: null, disabled: false }),
    comment: new FormControl({ value: null, disabled: false }),
  });
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store,
    private commonService: CommonService,
    private projectsService: ProjectsService,
  ) {
  }

  ngOnInit() {
    this.projectsService.changeView
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        if (data?.id) {
          this.data = data;

          if (this.data.status === 'passed') {
            this.passIsSelected = true;
            this.failIsSelected = false;
          }

          if (this.data.status === 'failed') {
            this.passIsSelected = false;
            this.failIsSelected = true;
          }
        }
      });

    if (this.data.status === 'passed') {
      this.passIsSelected = true;
      this.failIsSelected = false;
    }

    if (this.data.status === 'failed') {
      this.passIsSelected = false;
      this.failIsSelected = true;
    }

  }

  save() {
    const formValues = this.form.getRawValue();
    const payload = {
      comment: formValues?.comment,
      result: this.resultMap[formValues?.result] || formValues?.result,
      testId: this.data.id,
    };

    this.store.dispatch(UpdateExternalTestLabTestResultRequest({ payload }));
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField)),
    };
  }

  onLabelClick(type) {
    if (type === 'passed') {
      this.passIsSelected = true;
      this.failIsSelected = false;
      this.form.patchValue({
        result: 'passed',
      });
    }

    if (type === 'failed') {
      this.passIsSelected = false;
      this.failIsSelected = true;
      this.form.patchValue({
        result: 'failed',
      });
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
